module.exports = __webpack_public_path__ + "img/puente.c77a8ace.svg";